import * as ActionTypes from './actionTypes';

export const dismissMessageBox = () => {
  return {
    'type': ActionTypes.MESSAGE_BOX_DISMISSED,
    'payload': {
      'showMessage': false,
    },
  };
};

export const addMessageBoxError = (error) => {
  return {
    'type': ActionTypes.MESSAGE_BOX_ERROR_ADDED,
    'payload': {
      'showMessage': true,
      'error': error.message || error,
    },
  };
};

export const addMessageBoxWarning = (warning) => {
  return {
    'type': ActionTypes.MESSAGE_BOX_WARNING_ADDED,
    'payload': {
      'showMessage': true,
      warning,
    },
  };
};

export const addMessageBoxInfo = (info) => {
  return {
    'type': ActionTypes.MESSAGE_BOX_INFO_ADDED,
    'payload': {
      'showMessage': true,
      info,
    },
  };
};

export const customMessageBoxInfo = (data) => {
  return {
    'type': ActionTypes.MESSAGE_BOX_CUSTOM,
    'payload': {
      'showMessage': true,
      data,
    },
  };
};
